import { useState, useEffect, useCallback } from 'react';
import { usePlaceContext } from '../../components/itinerary/PlaceContext';
import useApi from '../../Api';
import { debounce } from 'lodash';

const usePlaceDetails = (origin_id) => {
    const { state, cachePlaceDetails, setCurrentOrigin } = usePlaceContext();
    const [placeDetails, setPlaceDetails] = useState(null);
    const api = useApi();

    const debouncedFetchOriginDetails = useCallback(debounce(async () => {
        if (!origin_id) return;

        const cachedPlace = state.placeCache[origin_id];
        if (cachedPlace) {
            setPlaceDetails(cachedPlace);
            if (state.currentOriginId !== origin_id) {
                setCurrentOrigin(origin_id);
            }
        } else {
            try {
                const response = await api.get(`/origin/${origin_id}`);
                const placeData = response.data;
                setPlaceDetails(placeData);
                cachePlaceDetails(origin_id, placeData);
                if (state.currentOriginId !== origin_id) {
                    setCurrentOrigin(origin_id);
                    state.itinerariesLoaded = false;
                }
            } catch (error) {
                console.error('Error fetching place details:', error);
            }
        }
    }, 300), [origin_id, state.placeCache, setCurrentOrigin, api, cachePlaceDetails]);

    useEffect(() => {
        debouncedFetchOriginDetails();
    }, [origin_id, debouncedFetchOriginDetails]);

    return placeDetails;
};

export default usePlaceDetails;
